<template>

    <div class="page">

        <kt-datatable
          :model="customerModel"  
          :data="list"
        >
          <template #view_actions="scope">
            <kt-dropmenu v-model:visible="actionDropdown['row_' + scope.row.Id]">
              <template #button>
                <button
                    class="btn btn-sm"
                    @click="actionDropdown['row_' + scope.row.Id] = !actionDropdown['row_' + scope.row.Id]"
                >
                  <span><i class="fas fa-ellipsis-v"></i></span>
                </button>
              </template>
              <template #dropmenu>
                <ul class="dropdown-menu show">
                  <li>
                    <label class="dropdown-item">
                      <button class="btn btn-sm btn-outline-primary form-control" @click="editRecord(scope.row.Id)">
                        <i class="fa fa-edit"></i> Edit
                      </button>
                    </label>
                  </li>
                  <li>
                    <label class="dropdown-item">
                      <button class="btn btn-sm btn-outline-info form-control" @click="viewStaff(scope.row)">
                        <i class="fa fa-user"></i> Contacts
                      </button>
                    </label>
                  </li>
                  <li>
                    <label class="dropdown-item">
                      <button class="btn btn-sm btn-outline-danger form-control" @click="deleteClient(scope.row.Id)">
                        <i class="fa fa-trash"></i> Delete
                      </button>
                    </label>
                  </li>
                </ul>
              </template>

              <template #after-search="scope">
                <div class="btn-group">
                <button @click="refresh()" 
                    class="btn btn-sm btn-outline-secondary"
                >Refresh <i class="fa fa-sync"></i></button>

                <button @click="newRecord()" 
                    class="btn btn-sm btn-outline-primary"
                >New <i class="fa fa-plus"></i></button>
                </div>
            </template>


            </kt-dropmenu>
          </template>

          <template #after-search="scope">
            <div class="btn-group">
          <button @click="refresh()" 
              class="btn btn-sm btn-outline-secondary"
          >Refresh <i class="fa fa-sync"></i></button>

          <button @click="newRecord()" 
              class="btn btn-sm btn-outline-primary"
          >New <i class="fa fa-plus"></i></button>
          </div>
        </template>
          
        </kt-datatable>
      
        <!-- Custom Contact Form -->
        <kt-modal
          :title="staffListTitle"
          :visible="staffListVisible"
          @dismiss="staffListDismiss()"
        >
          <template #body>
          <ul class="list-group">
            <li v-for="row in staff"
                class="list-group-item"
            >
              <div class="row">
                <div class="col-8">
                  <small>{{ row.Name }} : {{ row.Email }}</small>
                </div>
                <div class="col-4 text-end">
                  <div class="btn-group">
                    <button class="btn btn-sm btn-outline-danger" @click="staffDelete(row)">
                      <i class="fa fa-trash"></i>
                    </button>
                    <button class="btn btn-sm btn-outline-secondary" @click="staffEdit(row)">
                      <i class="fa fa-edit"></i>
                    </button>
                  </div>
                </div>
              </div>
            </li>
            <li class="list-group-item" v-if="!staff.length">
              <small><em>No Contacts Found</em></small>
            </li>
          </ul>
          <button class="btn btn-outline-secondary btn-sm mt-3" @click="addStaff()">
            <!-- <i class="fa fa-add"></i> -->
            <span>Add Contact</span>
          </button>
          </template>
        </kt-modal>
        <kt-modal
            :title="staffTitle"
            :visible="staffVisible"
            @dismiss="staffDismiss()"

        >
            <template #body>
                <staff-form v-model="staffForm"></staff-form>
            </template>

            <template #footer>
                <div class="container-fluid px-0">
                    <div class="row">
                        <div class="col">
                            <button 
                                @click="staffDismiss()" 
                                class="btn btn-sm btn-outline-secondary form-control"
                            >Close</button>
                        </div>
                        <div class="col">
                            <button 
                                @click="staffSave(staffForm)" 
                                class="btn btn-sm btn-outline-primary form-control"
                            >Save</button>
                        </div>
                    </div>
                </div>
            </template>

        </kt-modal>

        <router-view name="modal"></router-view>
    </div>
    
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from "vue";
import { useRouter } from 'vue-router';
import { storeToRefs } from "pinia";
import Api from "@/services/Api";
import Emitter from "@/services/Emitter";
import Validator from "@/services/Validator";

import Alert from "@/services/Alert";
import StaffForm from "@/components/Staff/StaffForm.vue";

import KtInput from "@/components/UI/KtInput.vue";
import KtModal from '@/components/UI/KtModal.vue';
import KtDropmenu from '@/components/UI/KtDropmenu.vue';
import { useClientStore } from '@/stores/ClientStore';
import KtDatatable from "@/components/UI/KtDatatable.vue";

const router = useRouter();
const clientStore = useClientStore();
const { list } = storeToRefs(clientStore);
const filter = ref("");
const unlisten = [];

const staffListTitle = ref("Contact List");
const staffListVisible = ref(false);

const staffTitle = ref("New Contact");
const staffVisible = ref(false);
const staffForm = ref({});

const toggled = ref({});
const staff = ref([]);
const actionDropdown = ref({});

const customerModel = [
  {
    name: "Actions",
    label: "Actions",
    type: "actions",
  },
  {
    name: "Id",
    display: false
  },
  {
    name: "CustomerNumber",
    label: "Customer Number",
    display: false,
  },
  {
    name: "Code",
    display: true,
  },
  {
    name: "Company",
    display: true,
  },
  {
    name: "RoundTripMileage",
    label: "Round Trip Mileage",
    display: false,
  },
  {
    name: "ContactInformation",
    label: "Contact Information",
    display: false,
  },
  {
    name: "Status",
    display: true,
    type: "boolean",
  },
  {
    name: "Phone",
    display: true
  }
];

const viewStaff = async (contact) =>
{
    // load client staff
    staff.value = await Api.loadStaff({
        CustomerNo: [contact.CustomerNumber],
        Page: 0,
        Size: 999999999
    });

    toggled.value = contact;
    staffListVisible.value = true;
};

const staffListDismiss = () =>
{
    staffListVisible.value = false;
}

const newRecord = () =>
{
    router.push({
        path: "/client/edit/new"
    });
};

const editRecord = (id) =>
{
    router.push({
        path: "/client/edit/" + id
    });

};

const staffSave = async (staff) =>
{

    let errs = Validator.checkStaff(staff);

    if (errs.length)
    {
        Alert.notify({
            text: errs.join(" ")
        });
        return;
    }

    await Api.saveStaff(staff);
    await viewStaff(toggled.value);

    staffDismiss();
    
};

const refresh = () =>
{
    clientStore.reload();
};

unlisten.push(Emitter.on("refresh", refresh));

const dismissModal = () =>
{
    router.push({
        path: "/"
    });
};

const addStaff = () =>
{
    let client = toggled.value;
    let staff = {};
    
    staff.ClientMap = [client.CustomerNumber];

    staffForm.value = staff;
    staffTitle.value = "Add Contact";
    staffVisible.value = true;
};

const staffEdit = async (row) =>
{
    let staff = await Api.loadStaffById(row.Id);

    console.debug(staff);

    // loop through clients and set customer numbers
    let cm = [];
    staff.ClientMap.forEach((val) => {
        // cm.push(val.CustomerNumber);
        cm.push(val.ClientRef);
    });


    staff.ClientMap = cm;
    
    staffForm.value = staff;
    staffTitle.value = "Edit Contact";
    staffVisible.value = true;

};

const staffDelete = (row) =>
{
    Alert.confirm("Do you want to remove that contact?", async () => {
        await Api.deleteStaff(row.Id);
        // await toggleRow(toggled.value);
        viewStaff(toggled.value);
    });
};

const staffDismiss = () =>
{
    staffVisible.value = false;
};

const deleteClient = (id) =>
{
    Alert.confirm("Are you sure you want to delete this client?", async () => {
        try {
            await Api.deleteClient(id);
            await clientStore.reload();
            Alert.notify({
                text: "Client deleted successfully",
                type: "success"
            });
        } catch (error) {
            Alert.notify({
                text: "Error deleting client: " + error.message,
                type: "error"
            });
        }
    });
};

const filtered = computed(() => 
{
    const filtered = [];
    const regOption = new RegExp(filter.value, "ig");
    for (const option of list.value) 
    {
        if (!filter.value || (option.Company || option.Code || "").match(regOption))
        {
            filtered.push(option);
        }
    }

    return filtered;
});

onMounted(async () =>
{
    await clientStore.reload();
});

onUnmounted(() =>
{
    unlisten.forEach((unlisten) => unlisten());
});


</script>